module.exports = __webpack_public_path__ + "static/media/algoritmo4.8b5c7e91.png";